import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import {
  getrecentCollectionSource,
  getrecentCollections,
} from "../services/recent-collection.service";

const useRecentCollection = (filter) => {
  const [recentCollections, setRecentCollections] = useState([]);
  const [filteredRecentCollection, setFilteredRecentCollection] = useState([]);
  const [recentCollectionSource, setRecentCollectionSource] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const { user } = useSelector((state) => state.auth);
  const userId = user?.userId;
  const abortControllerRef = useRef(null);

  useEffect(() => {
    const fetchInitialData = async () => {
      if (!userId) return;
      setIsLoading(true);
      try {
        const [collections, sources] = await Promise.all([
          getrecentCollections(user),
          getrecentCollectionSource(user, ""),
        ]);
        setRecentCollections(collections);
        setRecentCollectionSource(sources);
        setFilteredRecentCollection(sources);
      } catch (e) {
        console.error(e);
      } finally {
        setIsLoading(false);
      }
    };
    fetchInitialData();
  }, [userId]);

  useEffect(() => {
    abortControllerRef.current?.abort();
    if (!filter) {
      setFilteredRecentCollection(recentCollectionSource);
      return;
    }

    abortControllerRef.current = new AbortController();
    const signal = abortControllerRef.current.signal;

    const getFilteredCollectionSource = async () => {
      if (!userId) return;
      setIsLoading(true);
      try {
        const data = await getrecentCollectionSource(user, filter, signal);
        if (!signal.aborted) {
          setFilteredRecentCollection(data);
        }
      } catch (e) {
        if (e.name !== "AbortError") {
          console.error(e);
        }
      } finally {
        if (!signal.aborted) {
          setIsLoading(false);
        }
      }
    };
    getFilteredCollectionSource();

    return () => {
      abortControllerRef.current?.abort();
    };
  }, [filter, userId]);

  return {
    recentCollections,
    recentCollectionSource,
    filteredRecentCollection,
    isLoading,
  };
};

export default useRecentCollection;
